import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import afiladoc from '../../../../assets/images/Doctorsimages/afiladr.png'
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const AfilaDoc = () => {
  const navigate = useNavigate(); 
   useEffect(() => {
       document.title = "Dr. Afila Jabbar | Senior Homoeopathic Physician | Chronic Disease Specialist Chennai";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Afila Jabbar (BHMS) for comprehensive homoeopathic treatment of chronic diseases, autoimmune disorders, and lifestyle ailments at Hcura Clinic, Valasaravakkam."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "homoeopathy doctor Chennai, chronic disease specialist, natural asthma treatment, thyroid homoeopathy, PCOD treatment Chennai, autoimmune homoeopathy, Dr. Afila Jabbar BHMS, natural healing Chennai"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-afila-jabbar-chennai");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-afila-jabbar-chennai");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });
    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10; 
      const marginRight = 10; 
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }
      pdf.save('Dr_Afila_Jabbar_Homoeopathy_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      container.classList.remove('veenadoc-pdf-mode');
    });
  }, 100);
};

  // Fixed CSS for heading overflow
  const headingStyle = {
    overflowWrap: 'anywhere',
    wordBreak: 'normal',
    maxWidth: '100%',
    lineHeight: '1.4',
    display: 'block',
    whiteSpace: 'normal'
  };

  const diseaseCardStyle = {
    background: '#ffffff',
    padding: '24px',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(46, 125, 50, 0.05)',
    borderTop: '6px solid #2e7d32',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  };

  const diseaseHeadingStyle = {
    ...headingStyle,
    fontSize: '1.15rem',
    fontWeight: '700',
    color: '#1b5e20',
    marginBottom: '14px',
    minHeight: '2.8em', // Ensures alignment even if text wraps
    display: 'flex',
    alignItems: 'center'
  };

  const benefitItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '14px',
    marginBottom: '10px',
    background: 'linear-gradient(135deg, #f1f8e9 0%, #e8f5e9 100%)',
    borderRadius: '12px',
    fontSize: '14px',
    color: '#2e7d32',
    fontWeight: '600',
    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
    border: '1px solid #c8e6c9'
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title" style={headingStyle}>
                  <span className="veenadoc-title-highlight">Dr. Afila Jabbar</span>
                   <br />
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                 
                  <span className="veenadoc-title-location">Valasaravakkam, Chennai</span>
                </h1>
                <div className="veenadoc-hero-description">
                  <p>
                    Specializing in Classical Homoeopathy, Dr. Afila Jabbar provides individualized, 
                    side-effect-free healing for complex chronic diseases, hormonal imbalances, 
                    and autoimmune conditions.
                  </p>
                </div>
                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span>📞 Book Your Consultation</span>
                  </button>
                </div>
              </div>
              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <img src={afiladoc} alt="Dr. Afila Jabbar - Homoeopathic Specialist" className="veenadoc-doctor-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2 style={headingStyle}>Advanced Homoeopathic Care</h2>
                  <p>
                    Dr. Afila Jabbar (BHMS) offers a sophisticated approach to chronic illness, moving 
                    beyond surface-level symptom relief to achieve a "permanent restoration of health." 
                    Her clinical expertise is grounded in the deep study of the patient’s constitutional 
                    state, ensuring that the body’s innate vital force is stimulated to heal naturally.
                  </p>
                </div>

                {/* Fixed Specialized Areas Grid */}
                <div className="veenadoc-article-block">
                  <h2 style={headingStyle}>Specialized Treatment Areas & Diseases</h2>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginTop: '24px' }}>
                    <div style={diseaseCardStyle}>
                      <h4 style={diseaseHeadingStyle}>Autoimmune & Allergic Disorders</h4>
                      <p style={{ fontSize: '14.5px', color: '#444', lineHeight: '1.6' }}>
                        Expert management for <strong>Rheumatoid Arthritis</strong>, <strong>Psoriasis</strong>, <strong>Eczema</strong>, and 
                        <strong> Allergic Asthma</strong>. We focus on modulating the immune response to stop the body from attacking its own tissues.
                      </p>
                    </div>
                    <div style={diseaseCardStyle}>
                      <h4 style={diseaseHeadingStyle}>Hormonal & Endocrine Health</h4>
                      <p style={{ fontSize: '14.5px', color: '#444', lineHeight: '1.6' }}>
                        Natural solutions for <strong>Thyroid dysfunction</strong>, <strong>PCOD/PCOS</strong>, 
                        and <strong>irregular menstrual cycles</strong>. Our remedies target the endocrine axis to 
                        restore rhythm without synthetic hormones.
                      </p>
                    </div>
                    <div style={diseaseCardStyle}>
                      <h4 style={diseaseHeadingStyle}>Respiratory & Lung Health</h4>
                      <p style={{ fontSize: '14.5px', color: '#444', lineHeight: '1.6' }}>
                        Long-term relief for <strong>Chronic Sinusitis</strong>, <strong>Bronchitis</strong>, 
                        and <strong>Allergic Rhinitis</strong>. We treat the underlying sensitivity to environmental 
                        triggers like dust and seasonal changes.
                      </p>
                    </div>
                    <div style={diseaseCardStyle}>
                      <h4 style={diseaseHeadingStyle}>Digestive & Gastric Support</h4>
                      <p style={{ fontSize: '14.5px', color: '#444', lineHeight: '1.6' }}>
                        Holistic care for <strong>Irritable Bowel Syndrome (IBS)</strong>, <strong>Chronic Gastritis</strong>, 
                        <strong> Acid Reflux</strong>, and <strong>Peptic Ulcers</strong> by improving gut motility 
                        and digestive vitality.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2 style={headingStyle}>The Science of Individualization</h2>
                  <p>
                    Every consultation with Dr. Afila is an in-depth exploration of your health history. 
                    Homoeopathy recognizes that no two people experience a disease the same way. 
                    The consultation covers your physical generalities, mental state, and emotional 
                    stressors to arrive at a truly individualized prescription.
                  </p>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2 style={headingStyle}>Healing the Root Cause</h2>
                  <p>
                    At Hcura Multispeciality Clinic, Dr. Afila Jabbar is dedicated to helping you reclaim 
                    your life from chronic suffering. By choosing authentic homoeopathy, you are 
                    investing in a healthcare system that respects your body's natural intelligence 
                    and promotes long-lasting wellness.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-sidebar-card">
                  <h3 style={headingStyle}>Clinical Profile</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Degree:</span>
                      <span className="veenadoc-info-value">BHMS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Focus:</span>
                      <span className="veenadoc-info-value">Classical Homoeopathy</span>
                    </div>
                  </div>
                </div>

                {/* Enhanced Treatment Benefits Design */}
                <div className="veenadoc-sidebar-card" style={{ background: '#ffffff', border: '1px solid #e0e0e0', padding: '24px' }}>
                  <h3 style={{ ...headingStyle, marginBottom: '20px', color: '#2e7d32', textAlign: 'center' }}>Treatment Benefits</h3>
                  <div style={benefitItemStyle}>
                    <span style={{ fontSize: '20px' }}>⭐</span>
                    <span>100% Natural & Safe</span>
                  </div>
                  <div style={benefitItemStyle}>
                    <span style={{ fontSize: '20px' }}>⭐</span>
                    <span>Zero Side Effects</span>
                  </div>
                  <div style={benefitItemStyle}>
                    <span style={{ fontSize: '20px' }}>⭐</span>
                    <span>Deep Root Cause Resolution</span>
                  </div>
                  <div style={benefitItemStyle}>
                    <span style={{ fontSize: '20px' }}>⭐</span>
                    <span>Individualized Therapy</span>
                  </div>
                  <div style={benefitItemStyle}>
                    <span style={{ fontSize: '20px' }}>⭐</span>
                    <span>Safe for Infants & Seniors</span>
                  </div>
                </div>

                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">🌿</div>
                    <blockquote style={{ fontSize: '15px', fontStyle: 'italic', color: '#2e7d32' }}>
                      "My mission is to identify the internal root of every ailment to ensure wellness is gentle, rapid, and permanent."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Afila Jabbar</p>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3 style={headingStyle}>Consult Dr. Afila</h3>
                  <p>Start your journey toward side-effect-free healing today at Hcura Clinic.</p>
                 <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+918870001377'}>
                  <span>📞 Call +91 88700 01377</span>
                </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download Dr. Afila Jabbar Profile (PDF)
            </button>
          </div>
    </>
  )
}

export default AfilaDoc
